module.exports = __webpack_public_path__ + "static/media/gg_focus_finger.940dc0ce.gif";